import * as THREE from 'three';
import { useDailySunlightStore } from '@/store/dailySunlightsStore';
import { calculateSunlightScore } from '@/services/score/sunlight';
import { WorkflowProps } from '@/types/workflow';
import { openScoreModal } from '../AddScoreToRoomModal/AddScoreToRoomModal';

export const handleAddSunlightScoreModal = (
	roomName?: string,
	roomFillMesh?: THREE.Mesh,
	workflowProps?: WorkflowProps
) => {
	if (!workflowProps) return;

	// Get sunlight data from store
	const sunlightResultsRooms = useDailySunlightStore.getState().sunlightResultsRooms;

	// Filter sunlight results for the specific room
	const roomSunlightData =
		roomName && sunlightResultsRooms
			? sunlightResultsRooms.filter((r) => r.roomName === roomName)
			: null;

	const sunlightScore = roomSunlightData ? calculateSunlightScore(roomSunlightData) : null;

	if (!sunlightScore || !roomSunlightData) {
		console.warn('No sunlight data available for this grid cell');
		return;
	}

	// Prepare score data
	const scoreData = {
		totalScore: sunlightScore.totalScore,
		breakdown: {
			Winter: sunlightScore.winterScore.toFixed(1),
			Summer: sunlightScore.summerScore.toFixed(1),
			'Spring/Fall': sunlightScore.springFallScore.toFixed(1),
			'Points analyzed': sunlightScore.pointsAnalyzed.toString(),
			'Avg hours': `${sunlightScore.averageHours.toFixed(1)}h/day`,
		},
		data: roomSunlightData, // Include raw sunlight data to attach to room
		fullBreakdown: sunlightScore, // Include full breakdown for recommendations
	};

	openScoreModal({
		scoreType: 'sunlight',
		roomName,
		roomFillMesh,
		scoreData,
		workflowProps,
	});
};
